module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Danielle Abril","short_name":"Danielle Abril","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"standalone","icon":"static/images/photo.jpg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"33ae964bceee169ba89d35d434b58c5e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
